import React, { useContext, useEffect } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import { StoresContext } from '@App/contexts'
import { FetchType } from '@App/kit/components/WorkItemV2/fetch-type-enum'
import RootStore from '@App/stores/root-store'

const SubmissionStep = () => {
    const { workStore } = useContext<RootStore>(StoresContext)

    const determineWorkType = async (): Promise<void> => {
        if (workStore.createdWorkId) {
            await workStore.getWorkById(workStore.createdWorkId, FetchType.MLC)
        }
    }

    useEffect(() => {
        determineWorkType().then()
        workStore.setWizardStepValidation(true)

        return () => {
            workStore.destroyViewWork()
            workStore.setWizardStepValidation(false)
        }
    }, [])

    if (!workStore.workById) {
        return null
    }

    return (
        <div className="submission-step">
            <h2>Work Submitted for Registration</h2>
            <div className="submitted-work">
                <p className="bold" title={workStore.workById.title}>
                    {workStore.workById.title}
                </p>
                <div className="info">
                    <p className="ref">
                        Ref number: <strong>{workStore.workById?.id ?? workStore.createdWorkId}</strong>
                    </p>
                    <p className="small status">Submitted</p>
                </div>
            </div>
        </div>
    )
}

export default observer(SubmissionStep)
